"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AutorouteA1Google;
const react_1 = __importStar(require("react"));
function AutorouteA1Google() {
    const mapRef = (0, react_1.useRef)(null);
    const [map, setMap] = (0, react_1.useState)(null);
    const zones = [
        { name: "Dakar ↔ Diamniadio", lat: 14.72, lng: -17.35, zoom: 12 },
        { name: "Diamniadio ↔ AIBD", lat: 14.70, lng: -17.15, zoom: 12 },
        { name: "AIBD ↔ Thiès", lat: 14.76, lng: -17.00, zoom: 12 },
    ];
    const [activeZone, setActiveZone] = (0, react_1.useState)(zones[0]);
    const path = [
        { lat: 14.6937, lng: -17.4441 }, // Dakar
        { lat: 14.7127, lng: -17.2235 }, // Diamniadio
        { lat: 14.6715, lng: -17.0728 }, // AIBD
        { lat: 14.7915, lng: -16.9241 }, // Thiès
    ];
    // ✅ Chargement officiel (sans Loader, sans warnings)
    (0, react_1.useEffect)(() => {
        let mapInstance;
        const initMap = () => __awaiter(this, void 0, void 0, function* () {
            // Charger dynamiquement la bibliothèque "maps"
            const { Map, Polyline, TrafficLayer } = (yield google.maps.importLibrary("maps"));
            if (mapRef.current) {
                mapInstance = new Map(mapRef.current, {
                    center: { lat: activeZone.lat, lng: activeZone.lng },
                    zoom: activeZone.zoom,
                    mapTypeControl: false,
                    streetViewControl: false,
                    styles: [
                        { featureType: "water", stylers: [{ color: "#c9e6ff" }] },
                        { featureType: "road.highway", stylers: [{ color: "#05C2F2" }] },
                    ],
                });
                // Tracé de l’autoroute A1
                new Polyline({
                    path,
                    strokeColor: "#05C2F2",
                    strokeOpacity: 0.9,
                    strokeWeight: 5,
                    map: mapInstance,
                });
                // Calque de trafic
                new TrafficLayer({ map: mapInstance });
                setMap(mapInstance);
            }
        });
        // Charger le SDK s'il n'existe pas déjà
        if (!window.google || !window.google.maps) {
            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBlO_tkvp_UzrpV7XtC7a03mG9Vxc4T_gk`;
            script.async = true;
            script.defer = true;
            script.onload = initMap;
            document.body.appendChild(script);
        }
        else {
            initMap();
        }
        return () => {
            if (mapInstance)
                mapInstance = null;
        };
    }, []);
    // 🔄 Mise à jour du centre lors du changement de zone
    (0, react_1.useEffect)(() => {
        if (map) {
            map.setCenter({ lat: activeZone.lat, lng: activeZone.lng });
            map.setZoom(activeZone.zoom);
        }
    }, [activeZone, map]);
    return (react_1.default.createElement("div", { style: { textAlign: "center" } },
        react_1.default.createElement("h2", { style: { margin: "20px 0" } }, "\uD83D\uDE97 Trafic en direct \u2013 Autoroute A1 (Dakar \u2194 Thi\u00E8s)"),
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "15px",
            } }, zones.map((zone) => (react_1.default.createElement("button", { key: zone.name, onClick: () => setActiveZone(zone), style: {
                backgroundColor: zone.name === activeZone.name ? "#05C2F2" : "#E5E5E5",
                color: zone.name === activeZone.name ? "white" : "#333",
                padding: "10px 16px",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "0.2s",
            } }, zone.name)))),
        react_1.default.createElement("div", { ref: mapRef, style: {
                width: "100%",
                height: "600px",
                borderRadius: "12px",
                overflow: "hidden",
            } }),
        react_1.default.createElement("div", { style: {
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "20px",
            } },
            react_1.default.createElement(Legend, { color: "#05C2F2", label: "Trajet principal A1" }),
            react_1.default.createElement(Legend, { color: "#00FF00", label: "Trafic fluide" }),
            react_1.default.createElement(Legend, { color: "#FFA500", label: "Ralentissement" }),
            react_1.default.createElement(Legend, { color: "#FF0000", label: "Bouchon / Accident" }),
            react_1.default.createElement(Legend, { color: "#808080", label: "Travaux / Fermeture" }))));
}
function Legend({ color, label }) {
    return (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "6px" } },
        react_1.default.createElement("div", { style: {
                width: 20,
                height: 10,
                backgroundColor: color,
                borderRadius: 4,
                border: "1px solid #ccc",
            } }),
        react_1.default.createElement("span", { style: { fontSize: 14 } }, label)));
}
